import { observer } from "mobx-react-lite";
import './ComparisionCard.scss'
import { Badge } from "./Badge";
import BadgeIcon from "./BadgeIcon";
import PetTooltip from "./PetTooltip";
import { Button } from "./Button";
import { store } from "../stores/Store";
import Icon from "./Icon";
import { useElementSize } from "../effects/useElementSize";
import { useWindowSize } from "../effects/useWindowSize";
import { useRef } from "react";
import { BREAKPOINT_MD, BREAKPOINT_SM } from "../stores/constants";
import { publicUrl } from "../utils/url";
import ProductModel from "../stores/ProductModel";
import { formatCurrency } from "../utils/Currency";
import { _t } from '../utils/Lang';



const ComparisionCard = observer(({
    onClick,
    onMoreClick,
    item,
    className,
    checked = false,
    children
}: { item: ProductModel, className?: string, checked?: boolean, onClick?: Function, onMoreClick?: Function, children?: any }) => {

    const moreRef = useRef();
    // const [ref, size] = useElementSize();
    const size = useWindowSize();
    const {
        // bestseller = true,
        // description = '326 osób kupiło ostatnio',
        attributesHeader = '',
        attributes = [],
        image = publicUrl('/assets/materac.jpg'),
        price = '',
        name = 'Materac Classic',
    } = item || {}




    var classes = ['ComparisionCard', className];
    if (checked) {
        classes.push('ComparisionCard--checked');
    }
    // if (size.width < BREAKPOINT_SM) {
    //     classes.push('ComparisionCard--small');
    // }




    const _onMoreClick = (e) => {
        e.persist();
        console.log({ ref: moreRef.current, target: e.target, e });
        if (e.target === moreRef.current && onMoreClick) {
            onMoreClick();
            console.log('more click');
            e.preventDefault();
        }
    }

    return (
        <div
            onClick={(e) => {
                if (e.target.closest('.ComparisionCard__button') === null && e.target.closest('.badges') === null && typeof onClick === 'function') {
                    onClick();
                }
            }}
            className={classes.join(' ')}>



            <div className="ComparisionCard__body">
                <div className="ComparisionCard__photo-wrapper">
                    <div className="ComparisionCard__photo">
                        <img src={image} alt={name} />


                        {item.badgeText && <div className="ComparisionCard__bestseller">{item.badgeText}</div>}

                    </div>

                    {/* <div className="ComparisionCard__description">{item.who}</div> */}


                </div>
                <div className="ComparisionCard__text">
                    <div className="d-flex w-100 mt-2">
                        <div className="ComparisionCard__title flex-grow-1">{name}</div>
                    </div>
                    <Badge style={{
                        whiteSpace: 'nowrap'
                    }}>{formatCurrency(price)}</Badge>
                    <div className="ComparisionCard__header">{attributesHeader}</div>




                    {children}



                    <Button ref={moreRef} onClick={_onMoreClick} className="primary hollow btn-sm mt-2">{_t('learn_more')}</Button>

                </div>
            </div>
        </div>
    )
});

ComparisionCard.displayName = 'ComparisionCard'
export default ComparisionCard